export default {
  notAccessPage:"Sizda bu sahifaga ruxsat yo'q :(",
  goToCabinet:"Kabinetga qaytish",
  own:"Shaxsiy",
  invited:"Taklif qilingan",
  enterConfirmationCode: 'Tasdiqlash kodini kiriting',
  verificationCodeHasBeenSentYourNumber: 'Telefon raqamingizga verifikatsiya kodi yuborildi',
  shareLink:"Telefon raqami yoki havoladan foydalanib, siz do'stingiz yoki hamkasbingizni taklif qilishingiz mumkin",
  linkTeam: "Taklif havolasi yaratildi.",
  sendSmsAgain: "Qayta sms jo'natish",
  copyTaskLink:"Vazifa havolasini nusxalash",
  copyLink:"Havolani nusxalash",
  wantAddTeam:"sizni jamoaga qo'shmoqchi",
  sentSuccess:"Muvaffaqiyatli jo'natildi",
  successJoin:"Siz jamoaga muvaffaqiyatli qo'shildingiz",
  phoneError:"Telefon raqami 9 ta raqamdan iborat bo'lishi kerak",
  join:"Qo'shilish",
  send:"Yuborish",
  support: "Qo'llab-quvvatlash",
  REDColor: 'QIZIL',
  YELLOWColor: 'SARIQ',
  GREENColor: 'YASHIL',
  BLUEColor: 'KO`K',
  modules: 'Modullar',
  loading: 'Kuting...',
  systemErrorTitle: 'Tizim xatosi',
  systemErrorDescription: "Keyinroq qayta urinib ko'ring",
  noteName: 'Eslatma nomi',
  createNote: 'Eslatma yaratish',
  editNote: 'Eslatmani yangilash',
  changePlan: "Tarifni o'zgartirish",
  hitLimitDesc: "Davom etish uchun tarifingizni o'zgartiring",
  hitLimitTitle: 'Limitga yetdingiz',
  allTasks: 'Barcha vazifalar',
  newTask: 'Yangi vazifa',
  startFromScratch: 'Keling, noldan boshlaylik',
  teamNotFound: 'Jamoa topilmadi',
  teamNotFoundDesc: 'Sizda loyiha yaratish uchun jamoa mavjud emas',
  projectNotFound: 'Loyiha topilmadi',
  projectNotFoundDesc: 'Sizda vazifa yaratish uchun loyiha mavjud emas',
  singlyProject: 'Bittalik loyiha',
  newProject: 'Yangi loyiha',
  view: 'Ko‘rish',
  resetPassword: 'Parolni tiklash',
  selected: 'Tanlangan',
  selectAll: 'Hammasini tanlash',
  videoInstruction:"Video qo'llanma",
  creatTeamDescription: "O'zingizning orzuingizdagi jamoani yarating",
  createTeam: 'Jamoa yarating',
  managerNotFound: 'Menejer topilmadi!',
  managerNotFoundDescription:
    "Ushbu amalni bajarish uchun, foydalanuvchilar ro'yxati ichidan menejer tanlash kerak.",
  refreshBtn: 'Yangilash',
  attachManagerbtn: 'Menejerni tanlash',
  myNote: 'Mening eslatmalarim',
  gantt: 'Gantt',
  activity: 'Faolligi',
  activityInPlatform: 'Platformadagi faolligi',
  actionCount: 'Harakatlar soni',
  taskCount: 'Vazifalar soni',
  wastedTime: 'Vazifalarga sarflangan kunlik vaqt',
  noActivity: "Faolligi yo'q",
  enter: 'Kirdi',
  leave: 'Chiqdi',
  haveScreenShot: 'Screnshot mavjudmi',
  noScreenshot: 'Mavjud emas',
  yesScreenShot: 'Mavjud',
  onlyWithScreenshots: 'Faqat screnshotlari mavjudlari',
  dashboard: {
    language: 'Til',
    languageChange: 'Tilni o‘zgartirish'
  },
  notification: {
    error: 'Xatolik',
    warning: 'Ogohlantirish',
    success: 'Muvaffaqiyatli'
  },
  menu: {
    userActivity: 'Foydalanuvchilar faolligi',
    home: 'Bosh sahifa',
    task: 'Vazifa | Vazifalar',
    project: 'Loyiha | Loyihalar',
    user: 'Foydalanuvchi | Foydalanuvchilar',
    role: 'Rol | Rollar',
    organization: 'Tashkilot | Tashkilotlar',
    office: 'Ofis | Ofislar',
    company: 'Tashkilot | Tashkilotlar',
    department: "Bo'lim | Bo'limlar",
    permission: 'Huquq | Huquqlar',
    team: 'Jamoa | Jamoalar',
    report: 'Hisobot | Hisobotlar',
    projectOverview: 'Loyihalar umumiy hisoboti',
    projectReport: 'Proyektlar hisoboti',
    timeSeries: 'Ish vaqti tabeli',
    timeFrame: 'Bandlik hisoboti',
    projectDetailsTask: 'Loyihalar batafsil hisoboti',
    projectDetailsManager: 'Loyiha rahbarlari hisoboti',
    projectDetailsEmployee: 'Loyiha ijrochilari hisoboti',
    dailyReport: 'Kunlik hisobot',
    usersTasksReport: 'Foydalanuvchilarning vazifalari hisobot',
    reportEtmAgent: 'KPI-Agent hisoboti',
    staff: 'Xodimlar'
  },
  repoerts: {
    kanban: 'Kanban',
    boardName: 'Loyiha nomi',
    numberBoards: 'Loyihalar soni',
    sumTasks: 'Vazifalar soni',
    noTask: 'Vazifa yo‘q',
    tasksName: 'Vazifalar nomi'
  },
  actionItem: {
    CREATE_PROJECT: 'ushbu loyihani yaratdi',
    DELETE_PROJECT: 'ushbu loyihani o‘chirdi',
    CHANGE_PROJECT: '"{oldProName}" nomli loyhani "{newProName}" deb qayta nomladi',
    INVITE_MEMBER: '"{inviteUser}"ni ushbu loyihaga qo‘shdi',
    REMOVE_MEMBER: '"{removeUser}"ni ushbu loyihadan chiqarib yubordi',
    ADD_PROJECT_COLUMN: 'ushbu loyihaga "{addProColumn}" nomli ustun qo‘shdi',
    UPDATE_PROJECT_COLUMN:
      '"{updateNameColumn}" nomli ustunni  "{newNameColumn}" deb qayta nomladi',
    DELETED_PROJECT_COLUMN: '"{text}" nomli ustunni o‘chirdi',
    CREATE_TASK: '"{column}" nomli ustunda "{task}" nomli vazifa yaratdi',
    UPDATE_TASK: '"{oldTask}" nomli vazifani "{newTask}" deb qayta nomladi',
    DELETE_TASK: '"{text}" nomli vazifani o‘chirdi',
    MOVE_TASK:
      '"{task}" nomli vazifani "{oldColumn}" nomli ustundan "{newColumn}" nomli ustunga ko‘chirdi',
    COPY_TASK:
      '"{oldTask}" nomli vazifani "{column}" nomli ustunga "{newTask}" deb nusxasini ko‘chirdi',
    JOIN_TASK_MEMBER: '"{joinTask}" nomli vazifaga  "{joinMember}"ni qo‘shdi',
    REMOVE_TASK_MEMBER: '"{joinTask}" nomli vazifadan "{removeUser}"ni chiqarib yubordi',
    CREATE_CHECKLIST_GROUP:
      '"{taskName}" nomli vazifaga "{createGroup}" nomli nazorat ro‘yxatini qo‘shdi',
    DELETE_CHECKLIST_GROUP:
      '"{taskName}" nomli vazifadan "{deleteGroup}" nomli nazorat ro‘yxatini o‘chirdi ',
    CREATE_CHECKLIST_ITEM:
      '"{taskName}" nomli vazifaga "{checkListName}" nomli nazorat ro‘yxati elementi qo‘shdi',
    DELETE_CHECKLIST_ITEM:
      '"{taskName}" nomli vazifadan "{checkListText}" nomli nazorat ro‘yxati elementini o‘chirdi',
    COMPLETE_CHECKLIST_ITEM:
      '"{taskName}" nomli vazifadagi "{checkListText}" nomli nazorat ro‘yxati elementini belgiladi',
    ADD_COMMENT: '"{addName}" nomli vazifaga "{addComment}" deb izoh qoldirdi',
    ADD_CHECKLIST:
      '"{taskName}" nomli vazifaga "{checkListName}" nomli nazorat ro‘yxati elementi qo‘shdi',
    CHANGE_COMMENT:
      '"{taskName}" nomli vazifadagi  "{changeCommentOld}" izohni "{changeCommentNew}"ga o‘zgartirdi',
    DELETE_COMMENT: '"{taskName}" nomli vazifadan "{deleteComment}" izohini o‘chirdi',
    ADD_ATTACHMENT: '"{taskName}" nomli vazifaga "{addAttachment}" nomli faylni qo‘shdi',
    DELETE_ATTACHMENT: '"{taskName}" nomli vazifadan "{deleteAttachment}" nomli faylni o‘chirdi',
    ADD_DUE_DATE: '"{taskName}" nomli vazifaga "{addDate}" deb muddat qo‘ydi',
    UPDATE_TASK_DESCRIPTION:
      '"{taskName}" nomli vazifadagi  "{changeDescriptionOld}" vazifalar tavsifini "{changeDescriptionNew}"ga o‘zgartirdi'
  },
  boardColumn: {
    addTask: 'Vazifa qo‘shish',
    commentedCard: 'vazifani izohladi'
  },
  profileMenuModal: {
    editProfile: 'Profilni tahrirlash',
    uploadPhoto: 'Foto yuklash'
  },
  createTask: 'Vazifa yaratish',
  taskTitle: 'Vazifa nomini kiriting',
  nameIsRequired: '«Vazifa nomi» ni kiritish shart!',
  thereIsNoData: "Ma'lumot yo‘q",
  projectIsRequired: 'Loyihani tanlash shart',
  status: 'Holat',
  statusIsRequired: 'Ustunni tanlash shart',
  filter: 'Filtr',
  search: 'Qidirish',
  nameProject: 'Loyiha nomi',
  taskName: 'Vazifa nomi',
  deadline: 'Topshirish muddati',
  cancel: 'Bekor qilish',
  add: 'Qo‘shish',
  fullName: 'F.I.O',
  userName: 'Foydalanuvchi nomi',
  userNameProfile: 'Foydalanuvchi nomi',
  birthday: 'Tug‘ilgan sana',
  edit: 'Tahrirlash',
  delete: 'O‘chirish',
  addUser: 'Foydalanuvchini qo‘shish',
  uploadPhoto: 'Foto yuklash',
  password: 'Parol',
  name: 'Nomi',
  firstName: 'Ism',
  lastName: 'Familiya',
  middleName: 'Sharif',
  language: 'Til',
  email: 'E-mail',
  save: 'Saqlash',
  userEditing: 'Foydalanuvchini tahrirlash',
  editPhoto: 'Rasmni tahrirlash',
  addRole: 'Rol qo‘shish',
  nameRequiredField: 'Ismni kiritish shart',
  codeName: 'Kod nomi',
  codenameRequiredField: 'Kod nomini kiritish shart',
  id: 'ID',
  accessQuantity: 'Huquqlar soni',
  permissions: 'Huquqlar',
  editRole: 'Rolni tahrirlash',
  availablePermissions: 'Mavjud huquqlar',
  resolution: 'Rezolutsiya',
  editPermissions: 'Huquqlarni tahrirlash',
  normal: 'Oddiy',
  shownWith: 'ko‘rsatish',
  by: 'gacha',
  of: 'dan',
  emailAddress: 'Elektron pochta manzili',
  subject: 'Mavzu',
  message: 'Xabar',
  profile: 'Profil',
  rememberMyPreference: 'Mening afzalliklarimni saqlash',
  submit: 'Yuborish',
  downloadExcel: 'Excelda yuklash',
  day: 'Kun',
  week: 'Hafta',
  month: 'Oy',
  year: 'Yil',
  monday: 'Dushanba',
  tuesday: 'Seshanba',
  wednesday: 'Chorshanba',
  thursday: 'Payshanba',
  friday: 'Juma',
  saturday: 'Shanba',
  sunday: 'Yakshanba',
  mon: 'Du',
  tue: 'Se',
  wed: 'Chor',
  thu: 'Pay',
  fri: 'Juma',
  sat: 'Shan',
  sun: 'Yak',
  total: 'Jami',
  january: 'Yanvar',
  february: 'Fevral',
  mart: 'Mart',
  april: 'Aprel',
  may: 'May',
  june: 'Iyun',
  july: 'Iyul',
  august: 'Avgust',
  september: 'Sentyabr',
  october: 'Oktyabr',
  november: 'Noyabr',
  december: 'Dekabr',
  choose: 'Tanlash',
  executor: 'Ijrochi',
  priority: 'Muhimlik darajasi',
  deadlineLast: ' Oxirgi muddat',
  timeSpent: 'Sarflangan vaqt',
  menuW: 'Menyu',
  taskSearch: 'Vazifa qidirish',
  taskStatus: 'Vazifa holati',
  priorityHigh: 'Shoshilinch',
  priorityNormal: 'O‘rta',
  priorityLow: 'Past',
  changeBackground: 'Orqa fonni o‘zgartirish',
  projectSettings: 'Loyiha sozlash',
  actionsAndComments: 'Izohlar & Harakatlar',
  actions: 'Harakatlar',
  enterSearchTerm: 'Qidiruv so‘zini kiriting: so‘z, belgi, ism yoki vazifa muddati',
  column: 'Ustun',
  problem: 'Muammo',
  solution: 'Yechim',
  information: 'Axborot',
  attachment: 'Fayl yuklash',
  changeAttachment: 'Havola nomini yangilash',
  linkName: 'Link nomi',
  hideSelected: 'Belgilanganlarni bekitish',
  showTagged: 'Belgilanganlarni ko‘rsatish',
  tagSomeone: 'Belgilar',
  taskParticipants: 'Vazifa ishtirokchilari',
  description: 'Tavsif',
  tags: 'Belgilar',
  members: 'Ishtirokchilar',
  deadlineS: 'Vazifa muddati',
  notSet: 'o‘rnatilmagan',
  kvartalOne: 'kvartal - 1',
  kvartalTwo: 'kvartal - 2',
  kvartalThree: 'kvartal - 3',
  kvartalFour: 'kvartal - 4',
  addTags: 'Belgi qo‘shish',
  kvartal: 'kvartal',
  copyCard: 'Vazifani nusxalash',
  copyTask: 'Havolani nusxalash',
  copy: 'Nusxalash',
  copyTo: '...ga nusxalash',
  moveCard: 'Vazifani ko‘chirish',
  position: 'O‘rin',
  move: 'Ko‘chirish',
  difficultyLevel: 'Qiyinlik darajasi',
  taskCompletionDate: 'Topshiriqni bajarish sanasi',
  date: 'Sana',
  time: 'Vaqt',
  hour: 'Soat',
  minute: 'Daqiqa',
  chooseDateTime: 'Sana vaqtini tanlang',
  remove: 'Olib tashlash',
  checkList: 'Nazorat ro‘yxati',
  addTaskList: 'Nazorat ro‘yxatini qo‘shish',
  start: 'Boshlash',
  stop: 'To‘xtatish',
  phoneNumber: 'Telefon raqami',
  changePassword: 'Parolni o‘zgartirish',
  currentPassword: 'Joriy parol',
  fieldRequired: 'Majburiy maydon',
  minimumRequired: 'Minimal 6ta belgini kiritish kerak',
  passwordRepeatNew: 'Yangi parolni qayta tering',
  fieldNewPassword: 'Yangi parol bilan mos kelmayapti',
  logout: 'Chiqish',
  boardMembers: "Loyiha a'zolari",
  invite: 'Taklif qilish',
  inviteBoard: 'Loyihaga taklif qilish',
  searchEmployeeName: 'Xodimning ismini kiritish',
  workerFound: 'Ishchi topilmadi',
  addList: 'Ustun qo‘shish',
  addNewColumn: 'Yangi ustun qo‘shish',
  createProject: 'Loyiha yaratish',
  all: 'Hammasi',
  manager: 'Menejer',
  managers: 'Menejerlar',
  percent: 'Foiz',
  group: 'Guruh',
  typeProject: 'Loyiha ko‘rinishi',
  editProject: 'Loyihani tahrirlash',
  create: 'Yaratish',
  teamName: 'Jamoa nomi',
  departments: 'Bo‘limlar',
  BranchMaintenanceTerminals: 'Filialga xizmat ko‘rsatish terminallari',
  nameEmployee: 'Hodim F.I.Sh',
  more: 'Ko‘p',
  areYouSure: 'Ishonchingiz komilmi?',
  cannotUndoAction: 'Siz ushbu amalni bekor qilolmaysiz',
  deleteTask: 'Vazifani o‘chirish',
  deleteComment: "Kommentni o'chirish",
  saveAsPdf: 'PDFda saqlash',
  close: 'Yopish',
  permission: {
    HOMES: 'Home',
    HOMEPAGE: 'Главная',
    AUTH_TRY_CREATE: 'Avtorizatsiyani yaratish',
    AUTH_TRY_READ: 'Avtorizatsiyani ko‘rish',
    BACKGROUND_CREATE: 'Fon yaratish',
    BACKGROUND_DELETE: 'Fonni o‘chirish',
    BACKGROUND_READ: 'Fonni ko‘rish',
    BACKGROUND_UPDATE: 'Fonni yangilash',
    CERTIFICATE_UPDATE: 'Sertifikatni yangilash',
    CHECKLIST_GROUP_CREATE: 'Nazorat ro‘yxatini yaratish',
    CHECKLIST_GROUP_DELETE: 'Nazorat ro‘yxatini o‘chirish',
    CHECKLIST_GROUP_READ: 'Nazorat ro‘yxatini ko‘rish',
    CHECKLIST_GROUP_UPDATE: 'Nazorat ro‘yxatini yangilash',
    COIN_CREATE_AND_UPDATE: 'Nazorat ro‘yxatini yaratish va yangilash',
    COIN_READ: 'Nazoratni ko‘rish',
    EMPLOYEE_ALL_WITH_PHOTO: 'Foydalanuvchilarni hamma rasmi bilan',
    EMPLOYEE_CREATE: 'Foydalanuvchilarni yaratish',
    EMPLOYEE_DELETE: 'Foydalanuvchilarni o‘chirish',
    EMPLOYEE_READ: 'Foydalanuvchilarni ko‘rish',
    EMPLOYEE_UPDATE: 'Foydalanuvchilarni yangilash',
    ERROR_MESSAGE_CREATE: 'Xatolik haqida xabarni yaratish',
    ERROR_MESSAGE_DELETE: 'Xatolik haqida xabarni o‘chirish',
    ERROR_MESSAGE_READ: 'Xatolik haqida xabarni ko‘rish',
    ERROR_MESSAGE_UPDATE: 'Xatolik haqida xabarni yangilash',
    FILE_STORAGE_CREATE: 'Fayl omborini yaratish',
    FILE_STORAGE_READ: 'Fayl omborini ko‘rish',
    GROUP_CREATE: 'Guruh yaratish',
    GROUP_DELETE: 'Guruhni o‘chirish',
    GROUP_READ: 'Guruhni ko‘rish',
    GROUP_UPDATE: 'Guruhni yangilash',
    LANGUAGE_READ: 'Tilni ko‘rish',
    PERMISSION_CREATE: 'Huquqni yaratish',
    PERMISSION_DELETE: 'Huquqni o‘chirish',
    PERMISSION_READ: 'Huquqni ko‘rish',
    PERMISSION_UPDATE: 'Huquqlarni yangilash',
    PROJECT_CHANGE_PHOTO: 'Loyiha rasmini o‘zgartirish',
    PROJECT_COLUMN_CREATE: 'Loyiha ustunini yaratish',
    PROJECT_COLUMN_DELETE: 'Loyiha ustunini o‘chirish',
    PROJECT_COLUMN_READ: 'Loyiha ustunini ko‘rish',
    PROJECT_COLUMN_READ_DETAILS: 'Loyiha ustutinini batafsil ko‘rish',
    PROJECT_COLUMN_UPDATE: 'Loyiha ustunini yangilash',
    PROJECT_CREATE: 'Loyihani yaratish',
    PROJECT_DELETE: 'Loyihani o‘chirish',
    PROJECT_MEMBER_CREATE: 'Loyiha ishtirokchilarini yaratish',
    PROJECT_MEMBER_READ: 'Loyiha ishtirokchilarini ko‘rish',
    PROJECT_MEMBER_READ_EMPLOYEE: 'Loyihaga biriktirilgan ishtirokchilarni ko‘rish',
    PROJECT_READ: 'Loyihani ko‘rish',
    PROJECT_READ_DETAILS: 'Loyihani batafsil ko‘rish',
    PROJECT_TAG_CREATE: 'Loyiha belgilarini yaratish',
    PROJECT_TAG_DELETE: 'Loyiha belgilarini o‘chirish',
    PROJECT_TAG_READ: 'Loyiha belgilarini ko‘rish',
    PROJECT_TAG_UPDATE: 'Loyiha belgilarini yangilash',
    PROJECT_UPDATE: 'Loyihani yangilash',
    ROLE_ATTACH_PERMISSION: 'Huquqlarni rollarga biriktirish',
    ROLE_CREATE: 'Rol yaratish',
    ROLE_DELETE: 'Rol o‘chirish',
    ROLE_READ: 'Rol ko‘rish',
    ROLE_UPDATE: 'Rol yangilash',
    SUB_TYPE_CREATE: 'Tip-osti yaratish',
    TASK_ACTION_READ: 'Vazifa harakatlarini ko‘rish',
    TASK_ATTACHMENT_BIND: 'Vazifaga faylni biriktirish',
    TASK_ATTACHMENT_READ: 'Vazifa fayllarini ko‘rish',
    TASK_CHECK_CREATE: 'Vazifa tekshirishni yaratish',
    TASK_CHECK_DELETE: 'Vazifa tekshirishni o‘chirish',
    TASK_CHECK_READ: 'Vazifa tekshirishni ko‘rish',
    TASK_CHECK_UPDATE: 'Vazifa tekshirishni yangilash',
    TASK_COMMENT_CREATE: 'Vazifaga izoh yaratish',
    TASK_COMMENT_DELETE: 'Vazifa izohlarini o‘chirish',
    TASK_COMMENT_READ: 'Vazifa izohlarini ko‘rish',
    TASK_COMMENT_UPDATE: 'Vazifa izohlarini yangilash',
    TASK_CREATE: 'Vazifa yaratish',
    TASK_CREATE_TIME: 'Vazifa muddatini yaratish',
    TASK_DELETE: 'Vazifani o‘chirish',
    TASK_MEMBER_CREATE: 'Vazifa ishtirokchilarni yaratish',
    TASK_MEMBER_DELETE: 'Vazifa ishtirokchilarini o‘chirish',
    TASK_MEMBER_READ: 'Vazifa ishtirokchilarini ko‘rish',
    TASK_MOVE: 'Vazifani ko‘chirdi',
    TASK_READ: 'Vazifani ko‘rish',
    TASK_READ_DETAILS: 'Vazifa tafsilotlarini ko‘rish',
    TASK_TAG_CREATE: 'Vazifa tafsilotlarini yaratish',
    TASK_TAG_DELETE: 'Vazifa tafsilotlarini o‘chirish',
    TASK_TAG_READ: 'Vazifa tafsilotlarini ko‘rish',
    TASK_TAG_UPDATE: 'Vazifa tafsilotlarini yangilash',
    TASK_UPDATE: 'Vazifani yangilash',
    TYPE_CREATE: 'Turni yaratish',
    TYPE_DELETE: 'Turni o‘chirish',
    TYPE_READ: 'Turni ko‘rish',
    TYPE_UPDATE: 'Turni yangilash',
    USER_ATTACH_ROLE: 'Foydalanuvchini biriktirish roli',
    USER_CREATE: 'Foydalanuvchini yaratish',
    USER_DELETE: 'Foydalanuvchini o‘chirish',
    USER_READ: 'Foydalanuvchini ko‘rish',
    USER_UPDATE: 'Foydalanuvchini yangilash',
    REPORT_KANBAN_PROJECT_MANAGER_AND_MEMBER: "Kanban loyihasidagi hisobot menejeri va a'zosi",
    REPORT_TRELLO_PROJECT_MANAGER_AND_MEMBER: "Trello loyihasidagi hisobot menejeri va a'zosi",
    REPORT_CHART_KANBAN_PROJECT: 'Kanban loyhasidagi hisobot jadvali',
    REPORT_CHART_TRELLO_PROJECT: 'Trello loyhasidagi hisobot jadvali',
    REPORT_KANBAN_TRELLO_PROJECT_WITH_USER: 'Kanban va Trello loyhasidagi foydalanuvchi hisoboti',
    REPORT_TIME_LEFT: 'Hisobotga vaqti qoldi',
    REPORT_MANAGERS_MEMBERS_UPLOAD: "Hisobot menejerlarini va a'zolarini yuklaydi",
    REPORT_PERSONAL_UPLOAD: 'Shaxsiy yuklash haqida xabar berish',
    REPORT_TIME_LEFT_UPLOAD: 'Hisobotni yuklash vaqti',
    TASK_COPY: 'Vazifa nusxasini ko‘chirish',
    USER_LAST_LOGIN_CREATE: 'Foydalanuvchini oxirgi kirishni yaratish',
    USER_LAST_LOGIN_READ: 'Foydalanuvchini oxirgi kirishni ko‘rish',
    MANAGER_RENAME_TASK_PROJECT: 'Menejer nomini o‘zgartirish loyihasi',
    ORGANIZATION_CREATE: 'Tashkilot Yaratish',
    ORGANIZATION_UPDATE: 'Tashkilotni Tahrirlash',
    ORGANIZATION_DELETE: 'Tashkilotni O‘chirish',
    ORGANIZATION_READ: 'Tashkilotni ko‘rish',
    EMPLOYEE_PASSWORD_CHANGE: 'Parolni tiklash',
    EMPLOYEE_PROFILE_UPDATE: 'Profilni tahrirlash',
    ALARM_READ: 'Signalni ko‘rish',
    ALARM_UPDATE: 'Signalni tahrirlash',
    PROJECT_ARCHIVE: 'Loyihani arxivlash',
    REPORT_FOR_PROJECT: 'Foydalanuvchi vazifalari haqida hisobot',
    REPORT_ETM_DESKTOP: 'KPI-AGENT hisoboti'
  },
  createLabel: 'Belgi yaratish',
  newPassword: 'Yangi parol',
  comments: 'Sharhlar',
  nameOfEmployees: 'Xodimlarning ismi sharifi',
  notifications: 'Xabarnoma',
  markAllAsRead: 'Barchasini o‘qilgan deb belgilash',
  allRightsReserved: 'Barcha huquqlar himoyalangan',
  noList: 'Ro‘yxat yo‘q',
  newName: 'Yangi nom',
  indicateTheReasonForTheChange: 'O‘zgarish sababini ko‘rsating',
  completion: 'Tugatish',
  color: 'Rang',
  share: 'Ulashish',
  shareViaEmail: 'Email orqali ulashish',
  shareViaTelegram: 'Telegram orqali ulashish',
  writeAComment: 'Izoh qoldiring ...',
  workers: 'Xodimlar',
  added: 'Qo‘shilgan:',
  hoursAgo: ' soat oldin',
  minutesAgo: ' daqiqa oldin',
  secondsAgo: ' soniya oldin',
  in: '',
  to: '',
  at: '',
  addElement: 'Element qo‘shish',
  taskDescription: 'Vazifalar tavsifi',
  addedATask: 'vazifa qo‘shdi',
  byTerm: 'Muddati bo‘yicha',
  taskPriority: 'Vazifa ustuvorligi',
  taskDifficultyLevel: 'Vazifaning qiyinchilik darajasi',
  notDone: 'Tugallanmagan',
  completed: 'Tugallandi',
  overdue: 'Muddati o`tgan',
  expires: 'Muddati tugaydi',
  enough: 'Yetarli',
  notDelivered: 'Yetkazib berilmadi',
  complicated: 'Qiyin',
  easy: 'Engil',
  enoughTime: 'Vaqt yetarli',
  qrPaymentVending: 'QR to‘lovlari savdosi',
  toDo: 'Qilmoq',
  electronicTaskManagement: 'Elektron topshiriqlarni boshqarish',
  attachRole: 'Rolni biriktiring',
  searchCodeName: 'Qidiruv kod nomi',
  statusNameOfBoards: 'Holati (ustunlar nomi)',
  performers: 'Ijrochilar',
  pleaseCheckOneOrMoreUsers: 'Iltimos, bir yoki bir nechta foydalanuvchini tekshiring!',
  pleaseChooseATeamLeader: 'Iltimos, guruh rahbarini tanlang!',
  confirmDelete: "Siz haqiqatdan ham  shu vazifani ochirmoqchimisiz?",
  confirmDeleteTeam: "Jamoa o'chirilsa unga bog'langan loyihalar va vazifalar ham o'chib ketadi!",
  confirmDeleteProject: "Loyiha o'chirilsa loyihaga bog'langan vazifalar ham o'chiriladi!",
  WEEKLY_INTERVAL: 'Hafta',
  MONTHLY_INTERVAL: 'Oy',
  QUARTER_INTERVAL: 'Kvartal',
  YEARLY_INTERVAL: 'Yil',
  thisWeek: 'Bu hafta',
  lastWeek: 'O‘tgan hafta',
  last7Days: 'So‘nggi 7 kun',
  instruction: 'Qo‘llanma',
  guideVideo: 'Video',
  guidePDF: 'PDF xujjatlar',
  guidePPT: 'Taqdimot',
  noTaskFound: 'Vazifa topilmadi!',
  searchInThisProject: '"{message}" loyihada',
  paginationText: ' Ko‘rsatilgan: {shownText} dan {fromText} gacha {toText} tadan',
  wasOnline: 'Online edi',
  searchResult: 'ta qidiruv natijasi',
  board: 'Ustun',
  list: 'Ro‘yxat',
  HIGH_LEVEL: 'Yuqori',
  NORMAL_LEVEL: 'O‘rta',
  LOW_LEVEL: 'Oddiy',
  HIGH_PRIORITY: 'Shoshilinch',
  NORMAL_PRIORITY: 'O‘rta',
  LOW_PRIORITY: 'Past',
  YELLOW: 'Tugayotgan',
  GREEN: 'Yetarlicha',
  RED: 'Kechiktirilgan',

  Changed: 'O‘zgartirilgan',
  successfullyDeleted: 'O‘chirildi!',
  FileUploadedSuccessfully: 'Fayl yuklandi!',
  passwordChanged: 'Sizning parolingiz muvaffaqiyatli o‘zgartirildi!',
  profileEdited: 'Profilingiz muvaffaqiyatli tahrirlandi!',
  SuccessfullyUpdated: 'Yangilandi!',
  EditedBy: 'Tomonidan tahrirlangan',
  SuccessfullyAdded: 'Qo‘shildi!',
  SuccessfullyCreated: 'Yaratildi!',
  SuccessfullyChanged: 'O‘zgartirildi!',
  SuccessfullySent: 'Yuborildi!',
  SuccessfullyCopied: 'Nusxalandi!',
  TheTimerIsRunning: 'Taymer ishlamoqda!',
  TimerStopped: 'Taymer to‘xtadi',
  Added: 'Qo‘shildi',
  DeadlineSuccessfully: 'O‘rnatildi!',
  userUnblocked: 'Foydalanuvchi blokdan chiqarildi',
  userBlocked: 'Foydalanuvchi bloklandi',

  NEW: 'Yangi',
  DOING: 'Bajarilayotgan',
  DONE: 'Bajarilgan',
  VERIFY: 'Tasdiqlangan',
  ARCHIVE: 'Arxiv',
  NOTASKS: 'Hech nima qilmagan',
  ALL: 'Barchasi',
  ACTIVE: 'Faollar',

  TOTALPROJECTS: 'Loyihalarning umumiy soni',
  ACTIVEPROJECTS: 'Faol loyihalar soni',
  SUCCESSFULPROJECTS: 'Muvaffaqiyatli loyihalar soni',
  EXPIREDPROJECTS: "Muddati o'tgan loyihalar soni",
  TOTALTASKS: 'Vazifalarning umumiy soni',
  ACTIVETASKS: 'Faol vazifalar soni',
  SUCCESSFULTASKS: 'Muvaffaqiyatli vazifalar soni',
  EXPIREDTASKS: "Muddati o'tgan vazifalar soni",

  userTask: "Foydalanuvchining va'zifalari",
  TESTING: 'Test',

  select: 'Tanlang',
  projectType: 'Loyiha turi',
  columnName: 'Ustun nomi',
  notAvailable: 'Mavjud emas',
  deadlineType: 'Muddat turi',
  deadlineDate: 'Muddat sanasi',
  hasNoDeadline: 'Muddati yo‘q',
  inNextDay: 'Keyingi kun',
  inNextWeek: 'Keyingi hafta',
  inNextMonth: 'Keyingi oy',
  roleAbsent: 'Rol mavjud emas',
  columns: 'Ustunlar',
  organizationName: 'Tashkilot nomi',
  register: 'Ro‘yxatdan o‘tish',
  login: 'Kirish',
  back: 'Orqaga',
  confirm: 'Tasdiqlash',
  confirmationCode: 'Tasdiqlash kodi',
  confirmationCodeSent:
    'Tasdiqlash kodi {email} email manziliga va {phoneNumber} telefon raqamiga yuborildi',
  confirmationCodeSentSmall: 'Tasdiqlash kodi {text} ga yuborildi',
  passwordRepeat: 'Parolni qayta kiriting',
  forgotPassword: 'Parolni unutdingizmi?',
  resend: 'Qayta yuborish',
  pasteScreenshot: 'Skrinshotni shu yerga qo‘ying',
  crudCreate: 'Yangi {text} yaratish',
  crudEdit: '"{name}" nomli {table}ni tahrirlash',
  crudRead: '"{name}" nomli {table}ni ko‘rish',
  crudPasswordReset: '"{name}" nomli foydalanuvchining parolini tiklash',
  teamLeader: 'Jamoa rahbari',
  chief: 'Rahbar',
  photo: 'Rasm',
  Clear: 'Tozalash',
  selectedUsers: 'Tanlangan foydalanuvchilar',
  table: 'Jadval | Jadvallar',
  other: 'Boshqa | Boshqalar',
  tasksIamAssigned: 'Menga topshirilgan vazifalar',
  editInDashboard: 'Doskada tahrirlash',
  createdDate: 'Yaratilgan vaqt',
  deadlineStartDate: 'Muddat boshlanish vaqti',
  deadlineEndDate: 'Muddat tugash vaqti',
  systemAdmin: 'Tizim boshqaruvchisi',
  EVENT: 'Tadbir',
  weather: {
    Smoke: 'Bulutli',
    Mist: 'Tuman',
    Rain: "Yomg'ir",
    Sun: 'Quyosh',
    Clear: 'Ochiq',
    Clouds: 'Bulut',
    Thunderstorm: 'Momaqaldiroq',
    Snow: 'Qor',
    Drizzle: "Yog'ingarchilik"
  },
  myList: 'Mening ro‘yxatim',
  CONFERENCE: 'Konferensiya',
  ALERT: 'Ogohlantirish',
  BIRTHDAY: "Tug'ilgan kun",
  notSpecified: 'Ko‘rsatilmagan',
  passwordRecovery: 'Parolni tiklash',
  projectInDashboard: '"{name}" nomli loyiha – Doska',
  meta: {
    description: {
      login: 'KPI Kirish - tizimga kirish sahifasi',
      registration:
        'KPI Ro‘yxatdan o‘tish - yangi foydalanuvchilar uchun ro‘yxatdan o‘tish sahifasi',
      recovery: 'KPI Qayta tiklash - foydalanuvchilar uchun parolni tiklash sahifasi'
    },
    keywords: {
      login: 'kirish, kirmoq, ruxsat',
      registration: 'ro‘yxatdan o‘tish, hisob, profil, ruxsat',
      recovery: 'qayta tiklash, parol, unutmoq, ruxsat'
    }
  },
  projectsSelected: '{count} ta loyiha tanlab olindi',
  usersSelected: "{count} a'zo tanlandi",
  daily: 'Kunlik',
  weekly: 'Haftalik',
  monthly: 'Oylik',
  estimateDate: 'Vazifaga ajratiladigan vaqt',
  timeGridWeek: 'Soatbay Hafta',
  dayGridMonth: 'Kunbay OY',
  listWeek: 'Hafta List',
  dayGridWeek: 'Kunbay Hafta',
  today: 'Bugun',
  gantReport: {
    view: "Ko'rinish",
    viewModules: {
      quarter: 'Chorak',
      year: 'Yil',
      day: 'Kun',
      week: 'Hafta',
      month: 'Oy'
    }
  },
  dateFrom: 'Sana: Dan',
  To: 'Gacha',
  MyTasks: 'Mening vazifalarim',
  projectStatus: {
    ACTIVE: 'Faol',
    INACTIVE: 'No faol',
    successful: 'Muvaffaqiyatli',
    unsuccessful: 'Muvaffaqiyatsiz'
  }
};
